import { useState as r } from "react";
import { UrlsAPI as s } from "../../../../js/urls/index.js";
function m() {
  const [t, e] = r(!1);
  return {
    isPending: t,
    start: () => e(!0),
    cancel: () => {
      s.removeParamFromUrl("shared_secret"), e(!1);
    },
    complete: () => e(!1)
  };
}
export {
  m as useMagicLink
};
//# sourceMappingURL=useMagicLink.js.map
